import { CREATE_MODES, ECreateQuestionMode } from '../context/create-question.context';
import type { TVisibility } from 'types/template/template.types';

export type TAdminScopeContext = {
  mode: ECreateQuestionMode;
  visibility: TVisibility | null | undefined;
  clientId: string | undefined;
  accessGroupIds: string[] | undefined;
  templateClientId: string | undefined;
};

export type TAdminScopeCorrections = {
  clientId?: string;
  accessGroupIds?: string[];
};

/**
 * What a Hubert admin's question scope has to become: a question created in a template moves to the
 * template's client, a question that isn't local loses its groups, and a new local question without
 * groups gets the client's only group when there is just one.
 */
export const getAdminScopeCorrections = (
  context: TAdminScopeContext,
  clientAccessGroups: { id: string }[],
): TAdminScopeCorrections => {
  const { mode, visibility, clientId, accessGroupIds = [], templateClientId } = context;
  if (mode === ECreateQuestionMode.InTemplateEdit) return {};

  const isTemplateMode = [ECreateQuestionMode.InTemplateCreate, ECreateQuestionMode.InTemplateCopy].includes(mode);
  const corrections: TAdminScopeCorrections = {};

  if (
    isTemplateMode &&
    templateClientId &&
    clientId !== templateClientId &&
    (visibility === 'local' || visibility === 'client')
  ) {
    corrections.clientId = templateClientId;
  }

  const isLocal = visibility === 'local';
  if (!isLocal && accessGroupIds.length > 0) {
    corrections.accessGroupIds = [];
  }

  const isCreating = CREATE_MODES.includes(mode);
  if (isCreating && isLocal && accessGroupIds.length === 0 && clientAccessGroups.length === 1) {
    corrections.accessGroupIds = [clientAccessGroups[0].id];
  }
  return corrections;
};
